import { MultilineInput, TextInput } from '@silverfort/sf-components';
import { useSmartPolicyContext } from '../../SmartPolicyContext';
import useHasPermissions from '../../../../../../../hooks/useHasPermissions';
import { Pages, Roles } from '../../../../../../../context/contexts/UserContext/permissionsTypes';

const MAX_NAME_LENGTH = 50;
const MAX_DESCRIPTION_LENGTH = 500;

const PolicyInfo = () => {
    const { smartPolicyForEdit, setSmartPolicyForEdit } = useSmartPolicyContext();
    const isEditor = useHasPermissions({ permission: Pages.SERVICE_ACCOUNTS, role: Roles.EDITOR });
    if (!smartPolicyForEdit) return <></>;

    const updateName = (name: string) => {
        setSmartPolicyForEdit({
            ...smartPolicyForEdit,
            name: name
        });
    };

    const updateDescription = (description: string) => {
        setSmartPolicyForEdit({
            ...smartPolicyForEdit,
            description: description
        });
    };

    return (
        <div className="border border-sf-gray-100 rounded-md">
            <div className="p-4 border-b border-sf-gray-100 text-sf font-medium">Rule info</div>
            <div className="p-6 flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <div className="text-sf font-medium">Name *</div>
                    <TextInput
                        disabled={!isEditor}
                        className="w-full"
                        value={smartPolicyForEdit.name || ''}
                        onChange={updateName}
                        maxLength={MAX_NAME_LENGTH}
                        placeholder="My smart policy rule"
                    />
                </div>
                <div className="flex flex-col gap-2">
                    <div className="text-sf font-medium">Description</div>
                    <MultilineInput
                        disabled={!isEditor}
                        className={`border border-sf-gray-100 rounded-md w-full ${
                            isEditor ? '' : '!bg-sf-gray-100 disabled:!bg-sf-gray-100'
                        }`}
                        value={smartPolicyForEdit.description || ''}
                        onChange={updateDescription}
                        maxLength={MAX_DESCRIPTION_LENGTH}
                        placeholder="i.e. This rule is intended to protect highly privileged service accounts..."
                    />
                </div>
            </div>
        </div>
    );
};

export default PolicyInfo;
